import React, { useEffect, useMemo, useState } from "react";
import { Switch, Route, Redirect, NavLink } from "react-router-dom";
import { RoutedTabs, NavTab } from "react-router-tabs";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../_metronic/layout";
import { useIntl } from 'react-intl';
import { checkIsActive, getCurrentUrl } from "../../../_helpers";



export const BaseTabedPage = ({ components, basePath }) => {
    // Subheader
    const suhbeader = useSubheader();
    const intl = useIntl();

    return (
        <Card>
            <CardBody>

                <RoutedTabs
                    startPathWith={basePath}
                    className="nav nav-tabs nav-tabs-line"
                    activeTabClassName="nav-link active"
                    tabClassName="nav-link"
                    elementType="ul"
                // tabStyle={{ margin: "2px" }}
                // activeTabStyle={{ textDecoration: "underline" }}
                >
                    {components.map(item =>
                        <NavTab
                            to={item.url}
                        >
                            {intl.formatMessage({ id: item.title })}
                        </NavTab>
                    )}
                </RoutedTabs>




                <div className="mt-5">
                    <Switch>
                        <Route
                            exact
                            path={`${basePath}`}
                            render={() => <Redirect replace to={`${basePath}${components[0].url}`} />}
                        />
                        {components.map(item =>
                            <Route path={`${basePath}${item.url}`} key={item.id} component={item.component} />
                        )}

                    </Switch>
                </div>

            </CardBody>
        </Card>
    );
}

// export const BaseTabedPage = ({ components, basePath }) => {
//     // Subheader
//     const suhbeader = useSubheader();

//     const intl = useIntl();
//     // Tabs
//     // const { path } = props.match;
//     // const path = "/formList"
//     const [tab, setTab] = useState();
//     const [title, setTitle] = useState("");

//     const location = useLocation();
//     const current = getCurrentUrl(location);

//     useEffect(() => {
//         components.forEach(element => {
//             if (current.match(`${basePath}/${element.url}`))
//                 setTab(element.tab)
//         });
//     }, [])


//     const getTab = (item) => {
//         if (tab === item.tab) {
//             return item.component;
//         }
//     };

//     return (
//         <Card>
//             <CardBody>
//                 <ul className="nav nav-tabs nav-tabs-line " role="tablist">
//                     {components.map(item =>
//                         <li key={item.id} className="nav-item" onClick={() => setTab(item.tab)}>
//                             {/* <a
//                                 className={`nav-link ${tab === item.tab && "active"}`}
//                                 data-toggle="tab"
//                                 role="tab"
//                                 aria-selected={(tab === item.tab).toString()}
//                             >
//                                 {intl.formatMessage({ id: item.title })}
//                             </a> */}

//                             <NavLink className={`nav-link ${tab === item.tab && "active"}`}
//                                 to={`${basePath}/${item.url}`}
//                                 data-toggle="tab"
//                                 role="tab"
//                                 aria-selected={(tab === item.tab).toString()}
//                             >

//                                 <span className="menu-text">
//                                     {intl.formatMessage({ id: item.title })}
//                                 </span>
//                             </NavLink>

//                         </li>
//                     )}
//                 </ul>
//                 <div className="mt-5">
//                     {/* <Switch> */}
//                     {components.map(item =>
//                         //getTab(item)

//                         < Route path={`${basePath}/${item.url}`}>
//                             {() => (
//                                 getTab(item)
//                             )}
//                         </Route>

//                         // <Switch>
//                         //     {components.map(item =>
//                         //         <Route path={`${path}/${item.url}`} component={item.component} />
//                         //     )}

//                         // </Switch>
//                     )}
//                     {/* </Switch> */}
//                 </div>

//             </CardBody>
//         </Card>
//     );
// }


export const BaseTabedPageWhitoutRoute = ({ components }) => {
    // Subheader
    const suhbeader = useSubheader();

    const intl = useIntl();
    // Tabs
    // const { path } = props.match;
    // const path = "/formList"
    const [tab, setTab] = useState(components[0].tab);
    const [title, setTitle] = useState("");


    const getTab = (item) => {
        if (tab === item.tab) {
            return item.component;
        }
    };

    return (
        <Card>
            <CardBody>
                <ul className="nav nav-tabs nav-tabs-line " role="tablist">
                    {components.map(item =>
                        <li key={item.id} className="nav-item" onClick={() => setTab(item.tab)}>
                            <a
                                className={`nav-link ${tab === item.tab && "active"}`}
                                data-toggle="tab"
                                role="tab"
                                aria-selected={(tab === item.tab).toString()}
                            >
                                {intl.formatMessage({ id: item.title })}
                            </a>
                        </li>
                    )}
                </ul>
                <div className="mt-5">
                    {components.map(item =>
                        getTab(item)
                    )}
                </div>
            </CardBody>
        </Card>
    );
}


// const ExampleTabbed = ({ components }) => {
//     return (
//         <div>
//             <p>List Based</p>
//             <Nav>

//                 {components.map(item =>
//                     <NavItem>
//                         <NavLink to={item.url}>{item.title}</NavLink>
//                     </NavItem>
//                     // <li key={item.id} className="nav-item" onClick={() => setTab(item.tab)}>
//                     //     <a
//                     //         className={`nav-link ${tab === item.tab && "active"}`}
//                     //         data-toggle="tab"
//                     //         role="tab"
//                     //         aria-selected={(tab === item.tab).toString()}
//                     //     >
//                     //         {intl.formatMessage({ id: item.title })}
//                     //     </a>
//                     // </li>
//                 )}

//             </Nav>
//         </div>
//     );
// }

// export default ExampleTabbed;
